import { Redirect, useLocalSearchParams } from 'expo-router';

import { routes } from 'navigation/routing';
import { LoyaltyHistory } from 'pages/loyalty/loyalty-history/loyalty-history';
import { LoyaltyRewardsTabs } from 'pages/loyalty/loyalty-rewards/loyalty-rewards-tabs';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

export default function RewardsHistoryRoute() {
  const enableLoyaltyProfile = useFlag(LaunchDarklyFlag.ENABLE_LOYALTY_PROFILE);
  const { transactionId } = useLocalSearchParams<{ transactionId?: string }>();

  if (enableLoyaltyProfile) {
    return (
      <Redirect
        href={
          transactionId ? { pathname: routes.history, params: { transactionId } } : routes.history
        }
      />
    );
  }

  return (
    <>
      <LoyaltyRewardsTabs />
      <LoyaltyHistory />
    </>
  );
}
